<template>
  <MainLayout section="reports">
    <b-container fluid id="reports-container" v-bind:class="$mq">
      <b-row no-gutters>
        <b-col>
          <b-container id="report-container">
            <b-row>
              <b-col>
                <ReportHeader/>
              </b-col>

              <b-col style="text-align: right;">
                <router-link id="api_link" to="/api">API Docs</router-link>
              </b-col>
            </b-row>

            <b-row id="report_selector_container" v-bind:class="$mq">
              <b-col v-bind:cols="$mq == 'sm' ? 1 : 6" />
              <b-col v-bind:cols="$mq == 'sm' ? 11 : 6" style="padding-right: 3px">
                <ReportSelector />
              </b-col>
            </b-row>

            <b-row>
              <b-col v-bind:cols="selected_report ? 10 : ($mq == 'sm' ? 7 : 8)"
                     v-bind:style="{'font-size' : $mq == 'sm' ? '0.7em' : ''}">
                <ReportSectionsHeader />
              </b-col>

              <b-col class="p-0">
                <ReportDownload />
              </b-col>

              <b-col v-if="!selected_report" class="p-0">
                <ReportPerLedger/>
              </b-col>

              <b-col v-if="!selected_report">
                <ReportPeriod />
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <ReportContent />
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </MainLayout>
</template>

<script>
import MainLayout           from './components/MainLayout.vue'

import ReportHeader         from './components/report/Header.vue'
import ReportSelector       from './components/report/Selector.vue'
import ReportDownload       from './components/report/Download.vue'
import ReportPerLedger      from './components/report/PerLedger.vue'
import ReportPeriod         from './components/report/Period.vue'
import ReportSectionsHeader from './components/report/SectionsHeader.vue'
import ReportContent        from './components/report/Content.vue'

function set_params(vue){
  if(vue.isection)
    vue.section = vue.isection;
  else
    vue.section = 'ledgers';

  if(vue.iperiod)
    vue.period = vue.iperiod;
  else
    vue.period = '3600';

  if(vue.its)
    vue.timestamp = vue.its;
  else
    vue.clear_selected_report();
}

function subperiod_for(period){
  return period == 'month' ? '86400' :
         period == 'week'  ? '3600' :
                             '3600';
}

export default {
  name: 'Reports',

  components: {
    MainLayout,

    ReportHeader,
    ReportSelector,
    ReportDownload,
    ReportPerLedger,
    ReportPeriod,
    ReportSectionsHeader,
    ReportContent
  },

  props : {
     iperiod : String,
         its : String,
    isection : String
  },

  computed : {
    selected_report : function(){
      return this.$store.state.report.selected.period;
    },

    period : {
      get : function(){
        return this.$store.state.report.period;

      }, set : function(v){
        this.$store.commit('set_report_period', v);
      }
    },

    section : {
      get : function(){
        return this.$store.state.report.section;
      },

      set : function(s){
        this.$store.commit('set_report_section', s);
      }
    },

    timestamp : {
      get : function(){
        return this.$store.state.report.reports[this.period];
      },

      set : function(v){
        var subperiod = subperiod_for(this.period);
        this.$store.commit('set_selected_report',
                           {  period : this.period,
                           timestamp : v,
                           subperiod : subperiod });
      }
    },
  },

  methods : {
    clear_selected_report: function(){
      this.$store.commit('clear_selected_report'); // XXX
    },
  },

  watch : {
   '$route' : function(){
     set_params(this);
    }
  },

  created : function(){
    set_params(this);
  },
}
</script>

<style scoped>
#reports-container{
  flex-grow: 1;
  padding: 25px;
  padding-left: 0px;
  margin: 0;
  background: #ebeff0;
  font-family: 'Source Sans Pro';
}

#reports-container.sm,
#reports-container.md{
  padding: 0;
  padding-left: 0;
  font-size: 0.8em;
}

#report-container{
  background: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 20px;
}

#report_selector_container {
  transform: translateY(-25px);
  height: 25px;
}

#report_selector_container.sm{
  transform: unset;
  height: unset;
}

#api_link{
  font-size: 0.8em;
}
</style>
